/**
 * Lightweight analytics hook for the scratcher mechanism. By default events go
 * nowhere. Call `setEventReporter(fn)` to receive them (e.g. forward to GA / a8
 * impression tracking). Ported from the vendored scratcher-package (analytics.ts).
 */

let reporter = null;

export function setEventReporter(fn) {
  reporter = fn;
}

export function trackEvent(event, data) {
  if (reporter) reporter(event, data);
}
